export default __webpack_public_path__ + "static/media/logo_ACADEMONS@2x.ef3fb535.png";